/**
 * Holds the active Organization **slug** so the axios client attaches it to every
 * request (CLAUDE.md F1). Tenancy is carried by the `X-Organization` header,
 * separate from the JWT (which only authenticates the user).
 *
 * Confirmed against the dev13 `CurrentOrganizationMiddleware`: header name is
 * `X-Organization` and the value is the org **slug** (it resolves
 * `Organization.objects.filter(slug=...)`), not the id.
 *
 * The UI's org switcher (client state) is the writer; the axios request
 * interceptor is the reader. When the active org changes, also invalidate
 * org-scoped queries.
 */

export const ORG_HEADER = 'X-Organization';

let activeOrgSlug: string | null = null;

export const orgContext = {
  get(): string | null {
    return activeOrgSlug;
  },
  set(slug: string | null): void {
    activeOrgSlug = slug;
  },
};
